<template>
  <div class="settle">
    <nav-bar
      fixed
      z-index="99"
      title=""
      left-text="返回"
      left-arrow
      @click-left="$router.go(-1)"
    />
    <div style="height: 46px"></div>
    <div class="title">{{ stepActive === 1 ? "基本信息" : "完善资料" }}</div>
    <form class="settle-form acea-row row-column" @submit.prevent="submit">
      <div class="settle-box" v-if="stepActive === 1">
        <VueCoreImageUpload
          :crop="false"
          compress="80"
          @imageuploaded="imageuploaded($event, 'avatar')"
          :headers="headers"
          :max-file-size="5242880"
          :credentials="false"
          inputAccept="image/*"
          inputOfFile="file"
          :url="url"
        >
          <div class="box-item acea-row row-between-wrapper">
            <div class="name required">
              上传头像<span style="font-size: 0.24rem"
                >(750*750，大小不能超过5M)</span
              >
            </div>
            <div class="acea-row row-between-wrapper">
              <img class="box-item-header" :src="form.avatar" />
              <Icon name="arrow" color="#999999"></Icon>
            </div>
          </div>
        </VueCoreImageUpload>
        <div class="box-item">
          <div class="name required">真实姓名</div>
          <div class="input">
            <input
              v-model="form.realName"
              class="w-f"
              placeholder="请输入姓名"
            />
          </div>
        </div>
        <div class="box-item">
          <div class="name required">手机号</div>
          <div class="input">
            <input
              v-model="form.phone"
              class="w-f"
              type="number"
              placeholder="请输入手机号"
            />
          </div>
        </div>
        <div class="box-item" v-if="stepActive == 1">
          <div class="name required">验证码</div>
          <div class="input acea-row row-between-wrapper">
            <input
              v-model="form.code"
              class="w-f"
              type="number"
              placeholder="请输入验证码"
            />
            <div class="code" style="white-space: nowrap" @click="codeRequest">
              {{ text }}
            </div>
          </div>
        </div>

        <div class="box-item" v-if="$route.query.stepActive">
          <div class="name">邮箱</div>
          <div class="input">
            <input
              v-model="form.email"
              class="w-f"
              type="email"
              placeholder="请输入邮箱"
            />
          </div>
        </div>
        <!-- <div class="box-item" v-if="!this.$route.query.stepActive">
          <div class="name required">密码</div>
          <div class="input">
            <NfInput
              borderInnerSize="0"
              borderSize="0"
              padding="0"
              round=".5rem"
              :value.sync="form.password"
              placeholder="请输入密码"
              type="password"
            />
          </div>
          <div style="color: #ff1255; text-align: left; font-size: 0.24rem">
            密码长度不能少于6位，必须要大小写字母和数字组成
          </div>
        </div>
        <div class="box-item" v-if="!this.$route.query.stepActive">
          <div class="name required">确认密码</div>
          <div class="input">
            <NfInput
              borderInnerSize="0"
              borderSize="0"
              padding="0"
              round=".5rem"
              :value.sync="form.rePassword"
              placeholder="请再次输入密码"
              type="password"
            />
          </div>
        </div> -->
        <div class="box-item" v-if="$route.query.stepActive">
          <div class="name">微信号</div>
          <div class="input">
            <input
              v-model="form.wechatNumber"
              class="w-f"
              placeholder="请输入微信号"
            />
          </div>
        </div>
        <template v-if="$store.state.app.userCategory == 2">
          <div class="box-item" v-if="$route.query.stepActive">
            <div class="name">银行名称</div>
            <div class="input">
              <input
                v-model="form.bankName"
                class="w-f"
                placeholder="请输入银行名称"
              />
            </div>
          </div>
          <div class="box-item" v-if="$route.query.stepActive">
            <div class="name">银行卡号</div>
            <div class="input">
              <input
                v-model="form.bankNumber"
                class="w-f"
                placeholder="请输入银行卡号"
              />
            </div>
          </div>
          <div class="box-item" v-if="$route.query.stepActive">
            <div class="name">支付宝名称</div>
            <div class="input">
              <input
                v-model="form.zfbName"
                class="w-f"
                placeholder="请输入支付宝名称"
              />
            </div>
          </div>
          <div class="box-item" v-if="$route.query.stepActive">
            <div class="name">支付宝账号</div>
            <div class="input">
              <input
                v-model="form.zfbNumber"
                class="w-f"
                placeholder="请输入支付宝账号"
              />
            </div>
          </div>
        </template>
      </div>
      <div class="settle-box" v-if="stepActive === 2">
        <div class="box-item acea-row row-between-wrapper">
          <div class="name required">选择性别</div>
          <div class="acea-row row-between-wrapper">
            <div
              class="sex-item"
              :class="{ active: form.sex == item.value }"
              @click="form.sex = item.value"
              v-for="(item, index) in sexList"
              :key="index"
            >
              <svg
                t="1683182891346"
                class="icon"
                viewBox="0 0 1024 1024"
                version="1.1"
                xmlns="http://www.w3.org/2000/svg"
                p-id="19642"
                width="64"
                height="64"
                v-if="item.label === '男'"
              >
                <path
                  d="M456.57732 427.546392c-79.175258 0-142.515464 63.340206-137.237114 142.515464 0 73.896907 63.340206 137.237113 137.237114 137.237113 36.948454 0 73.896907-15.835052 100.288659-42.226804s42.226804-63.340206 36.948454-100.28866c0-79.175258-63.340206-137.237113-137.237113-137.237113z"
                  fill="#bfbfbf"
                  p-id="19643"
                ></path>
                <path
                  d="M514.639175 31.670103c-263.917526 0-475.051546 211.134021-475.051546 475.051546s211.134021 475.051546 475.051546 475.051547 475.051546-211.134021 475.051547-475.051547-211.134021-475.051546-475.051547-475.051546z m263.917526 242.804124v221.690721c0 15.835052-10.556701 26.391753-26.391753 26.391753s-26.391753-10.556701-26.391752-26.391753V343.092784l-100.28866 100.288659c26.391753 31.670103 36.948454 73.896907 42.226804 116.123712 0 52.783505-21.113402 105.56701-58.061855 147.793814-36.948454 36.948454-89.731959 63.340206-142.515464 63.340206h-5.278351c-110.845361 0-200.57732-89.731959-205.85567-200.577319 0-110.845361 89.731959-205.85567 200.57732-205.85567h5.27835c47.505155 0 89.731959 15.835052 126.680412 42.226804l100.28866-100.28866H535.752577c-15.835052 0-26.391753-10.556701-26.391752-26.391753s10.556701-26.391753 26.391752-26.391752h226.969072l15.835052 21.113402c0-5.278351 0-5.278351 0 0 0-5.278351 0 0 0 0z"
                  fill="#bfbfbf"
                  p-id="19644"
                ></path>
              </svg>
              <svg
                t="1683183057128"
                class="icon"
                viewBox="0 0 1024 1024"
                version="1.1"
                xmlns="http://www.w3.org/2000/svg"
                p-id="38845"
                width="64"
                height="64"
                v-else
              >
                <path
                  d="M417.16736 450.56c0 87.72608 71.11168 158.83264 158.83264 158.83264 87.72608 0 158.83264-71.11168 158.83264-158.83264S663.72096 291.72736 576 291.72736 417.16736 362.83904 417.16736 450.56z"
                  fill="#bfbfbf"
                  p-id="38846"
                ></path>
                <path
                  d="M512 0C230.4 0 0 230.4 0 512s230.4 512 512 512 512-230.4 512-512S793.6 0 512 0z m217.6 596.48c-76.8 74.24-194.56 84.48-281.6 20.48L409.6 655.36l87.04 87.04-43.52 43.52-87.04-87.04L276.48 788.48l-43.52-43.52L322.56 655.36l-87.04-87.04 43.52-43.52 87.04 87.04 40.96-40.96c-61.44-84.48-51.2-202.24 23.04-276.48 84.48-71.68 209.92-66.56 289.28 12.8s81.92 204.8 10.24 289.28z"
                  fill="#bfbfbf"
                  p-id="38847"
                ></path>
              </svg>
              <p>{{ item.label }}</p>
            </div>
          </div>
        </div>
        <div class="box-item" @click="selectPicker('province')">
          <div class="name required">所在省份</div>
          <div class="input acea-row row-between-wrapper">
            <div :class="{ empty: !province.n }">
              {{ province.n || "请选择所在省份" }}
            </div>
            <Icon name="arrow" color="#999999"></Icon>
          </div>
        </div>
        <div class="box-item" @click="selectPicker('city')">
          <div class="name required">所在城市</div>
          <div class="input acea-row row-between-wrapper">
            <div :class="{ empty: !city.n }">
              {{ city.n || "请选择所在城市" }}
            </div>
            <Icon name="arrow" color="#999999"></Icon>
          </div>
        </div>
        <div class="box-item">
          <div class="name required">累计教练时间</div>
          <div class="input">
            <input
              v-model="form.coachTime"
              class="w-f"
              type="number"
              placeholder="请输入累计教练时间（小时）"
            />
          </div>
        </div>
        <div class="box-item">
          <div class="name required">累计教练学习时长</div>
          <div class="input">
            <input
              v-model="form.teachTime"
              class="w-f"
              type="number"
              placeholder="请输入累计教练学习时长（小时）"
            />
          </div>
        </div>
        <div class="box-item">
          <div class="name required">从事职业</div>
          <div class="input">
            <input
              v-model="form.practiceExperience"
              class="w-f"
              placeholder="请输入从事职业"
            />
          </div>
        </div>
        <div class="box-item">
          <div class="name">链接标题</div>
          <div class="input">
            <input
              class="w-f"
              v-model="form.title"
              :placeholder="`请输入链接标题`"
            />
          </div>
        </div>
        <div class="box-item">
          <div class="name">链接地址</div>
          <div class="input">
            <input
              class="w-f"
              v-model="form.linkUrl"
              :placeholder="`请输入链接地址`"
            />
          </div>
        </div>
        <div class="box-item">
          <div class="name required">详细介绍</div>
          <div class="input">
            <textarea
              rows="10"
              v-model="form.storeInfo"
              class="w-f"
              placeholder="请输入详细介绍"
            />
          </div>
        </div>
        <div class="box-item">
          <div class="name required">
            擅长领域<span style="color: #999999">(最多可选3个)</span>
          </div>
          <div class="acea-row row-between-wrapper row-wrap" v-if="form.cateId">
            <div
              class="zone-item"
              :class="{ active: form.cateId.includes(item.id) }"
              v-for="(item, index) in zone"
              :key="index"
              @click="zoneChoose(item.id)"
            >
              <img class="icon" :src="item.pic" />
              <p>{{ item.cateName }}</p>
            </div>
          </div>
          <div class="name" style="margin-top: 0.19rem">
            自定义领域（每个不超过6字，多个以逗号分割）
          </div>
          <div class="input">
            <input
              class="w-f"
              v-model="form.keyword"
              placeholder="请输入自定义领域，多个以,分开"
            />
          </div>
        </div>
        <div class="box-item">
          <div class="name required">约见方式</div>
          <div class="acea-row row-between-wrapper">
            <div
              class="zone-item zone-appointment"
              :class="{ active: form.meetType.includes(item.value) }"
              v-for="(item, index) in meetList"
              :key="index"
              @click="appointmentChoose(item.value)"
            >
              <img
                v-if="item.label.indexOf('线上') !== -1"
                class="icon"
                src="https://coach.pgyfamilycoach.com/images/static/file/pic/20230517180131539773.png"
              />
              <img
                v-else
                class="icon"
                src="https://coach.pgyfamilycoach.com/images/static/file/pic/20230517180131540834.png"
              />
              <p>{{ item.label }}</p>
            </div>
          </div>
        </div>
        <div class="box-item" @click="pricePicker = true">
          <div class="name required">单次价格</div>
          <div class="input acea-row row-between-wrapper">
            <div :class="{ empty: !form.price }">
              {{ form.price || "首次价格" }}
            </div>
            <Icon name="arrow" color="#999999"></Icon>
          </div>
        </div>
        <template v-for="memberItem in memberList">
          <!-- <el-col :span="8" :key="memberItem.id">
            <el-form-item :label="memberItem.name">
              <el-input
                disabled
                :value="
                  (
                    form.price *
                    memberItem.number *
                    memberItem.discount
                  ).toFixed(2)
                "
              />
            </el-form-item>
          </el-col> -->

          <div class="box-item" :key="memberItem.id">
            <div class="name">{{ memberItem.name }}</div>
            <div class="input">
              <input
                disabled
                class="w-f"
                type="number"
                :value="
                  (
                    form.price *
                    memberItem.number *
                    memberItem.discount
                  ).toFixed(2)
                "
                :placeholder="memberItem.name"
              />
            </div>
          </div>
        </template>
        <!-- <div class="box-item">
          <div class="name">个人套餐7次（仅适合成人参加）</div>
          <div class="input">
            <input
              disabled
              class="w-f"
              type="number"
              :value="priceObj['7'] ? priceObj['7'] : ''"
              :placeholder="`根据单次价格并且按${packageObj['7']}折计算`"
            />
          </div>
        </div>
        <div class="box-item">
          <div class="name">家庭套餐15次</div>
          <div class="input">
            <input
              disabled
              class="w-f"
              type="number"
              :value="priceObj['15'] ? priceObj['15'] : ''"
              :placeholder="`根据单次价格并且按${packageObj['15']}折计算`"
            />
          </div>
        </div> -->
      </div>
      <div class="settle-box" v-if="stepActive === 3">
        <div v-if="status == 0">
          <div class="upload-item">
            <div class="name required red">上传身份证</div>
            <div class="msg">
              请上传本人有效二代身份证，请确保身份证边框完整、图像清晰、光线均匀
            </div>
            <div class="upload-box">
              <VueCoreImageUpload
                :crop="false"
                compress="80"
                @imageuploaded="imageuploaded($event, 'cardFront')"
                :headers="headers"
                :max-file-size="5242880"
                :credentials="false"
                inputAccept="image/*"
                inputOfFile="file"
                :url="url"
              >
                <img
                  class="id-img"
                  v-if="form.cardFront"
                  :src="form.cardFront"
                />
                <img
                  class="id-img"
                  v-else
                  src="../../assets/img/id_front.png"
                />
              </VueCoreImageUpload>
              <p>身份证正面</p>
            </div>
            <div class="upload-box">
              <VueCoreImageUpload
                :crop="false"
                compress="80"
                @imageuploaded="imageuploaded($event, 'cardBack')"
                :headers="headers"
                :max-file-size="5242880"
                :credentials="false"
                inputAccept="image/*"
                inputOfFile="file"
                :url="url"
              >
                <img class="id-img" v-if="form.cardBack" :src="form.cardBack" />
                <img class="id-img" v-else src="../../assets/img/id_back.png" />
              </VueCoreImageUpload>
              <p>身份证背面</p>
            </div>
          </div>
          <div class="upload-item">
            <div class="name">上传护照</div>
            <div class="upload-box">
              <VueCoreImageUpload
                :crop="false"
                compress="80"
                @imageuploaded="imageuploaded($event, 'passport')"
                @errorhandle="imageErrorhandle"
                :headers="headers"
                :max-file-size="5242880"
                :credentials="false"
                inputAccept="image/*"
                inputOfFile="file"
                :url="url"
              >
                <img
                  class="passport-img"
                  v-if="form.passport"
                  :src="form.passport"
                />
                <img
                  class="passport-img"
                  v-else
                  src="../../assets/img/passport.png"
                />
              </VueCoreImageUpload>
            </div>
          </div>
          <div class="upload-item">
            <div class="name required red">上传资质证明</div>
            <div class="msg">
              教练资质证书、学习证书、标签中如出现心理咨询方向或背景，需要提供相关资质证书。
            </div>
            <div class="upload-box acea-row row-wrap">
              <div
                class="more-img"
                v-for="(item, index) in form.aptitudeList"
                :key="index"
              >
                <img style="width: 100%; height: 100%" :src="item" />
                <Icon
                  size="0.6rem"
                  @click="form.aptitudeList.splice(index, 1)"
                  class="close-img"
                  name="clear"
                  color="#333333"
                ></Icon>
              </div>
              <VueCoreImageUpload
                :crop="false"
                compress="80"
                @imageuploaded="imageMoreUploaded"
                @errorhandle="imageErrorhandle"
                :headers="headers"
                :max-file-size="5242880"
                :credentials="false"
                inputAccept="image/*"
                inputOfFile="file"
                :url="url"
              >
                <img class="more-img" src="../../assets/img/other_img.png" />
              </VueCoreImageUpload>
            </div>
          </div>
          <div class="upload-item">
            <div class="name">上传个人海报（750*800非必填）</div>
            <div class="upload-box acea-row row-wrap">
              <div
                class="more-img"
                style="height: auto"
                v-for="(item, index) in form.posterList"
                :key="index"
              >
                <img style="width: 100%" :src="item" />
                <Icon
                  size="0.6rem"
                  @click="form.posterList.splice(index, 1)"
                  class="close-img"
                  name="clear"
                  color="#333333"
                >
                </Icon>
              </div>
              <VueCoreImageUpload
                :crop="false"
                compress="80"
                @imageuploaded="imagePosterUploaded"
                @errorhandle="imageErrorhandle"
                :headers="headers"
                :max-file-size="5242880"
                :credentials="false"
                inputAccept="image/*"
                inputOfFile="file"
                :url="url"
              >
                <img class="more-img" src="../../assets/img/other_img.png" />
              </VueCoreImageUpload>
            </div>
          </div>
        </div>
        <div v-if="status == 1">
          <Icon name="clock" color="#ddaa35" size="2rem" />
          <p>审核中</p>
        </div>
        <div v-if="status == 2">
          <Icon name="checked" color="#0ce6df" size="2rem" />
          <p>审核通过</p>
        </div>
        <div v-if="status == 3">
          <Icon name="clear" color="#ff4400" size="2rem" />
          <p>驳回</p>
          <div class="btn" @click="status = 0">重新提交</div>
        </div>
      </div>
      <div class="btn" @click="save" v-if="$route.query.stepActive">保存</div>
      <div v-else>
        <div
          v-if="stepActive != 1"
          @click="coachRegister('coach')"
          class="btn"
          style="display: flex; justify-content: center"
        >
          <div
            style="width: 40%; justify-content: space-between; display: flex"
          >
            保存进入下一步
          </div>
        </div>
        <!--         
        <div @click="coachRegister('card')" v-if="stepActive === 1 && isCardCoach != 1" class="btn"
          style="margin-bottom: 10px; display: flex; justify-content: center">
          <div style="width: 40%; justify-content: space-between; display: flex">
            <span>卡牌引导师</span>
            <span>提交</span>
          </div>
        </div> -->
        <div
          @click="coachRegister('card')"
          v-if="
            stepActive === 1 &&
            (userInfo.isCardCoach != 1 ||
              (userInfo.isCardCoach == 1 && userInfo.cardStatus == 2))
          "
          class="btn"
          style="margin-bottom: 10px; display: flex; justify-content: center"
        >
          <div
            style="width: 40%; justify-content: space-between; display: flex"
          >
            <span>卡牌引导师</span>
            <span>提交</span>
          </div>
        </div>
        <div
          v-if="
            stepActive == 1 &&
            (![0, 2].includes(userInfo.coachType) ||
              ([0, 2].includes(userInfo.coachType) && userInfo.isShow == 2))
          "
          @click="coachRegister('coach')"
          class="btn"
          style="display: flex; justify-content: center"
        >
          <div
            style="width: 40%; justify-content: space-between; display: flex"
          >
            <span>平台入驻教练</span>
            <span>继续</span>
          </div>
        </div>
        <div
          @click="coachRegister('welfare')"
          v-if="
            stepActive === 1 &&
            (![1, 2].includes(userInfo.coachType) ||
              ([1, 2].includes(userInfo.coachType) &&
                userInfo.welfareStatus == 2))
          "
          class="btn"
          style="margin-top: 10px; display: flex; justify-content: center"
        >
          <div
            style="width: 40%; justify-content: space-between; display: flex"
          >
            <span>公益教练</span>
            <span>提交</span>
          </div>
        </div>
      </div>
    </form>
    <Popup v-model="showPicker" round position="bottom">
      <Picker
        value-key="n"
        show-toolbar
        :columns="columns"
        @cancel="showPicker = false"
        @confirm="onConfirm"
      />
    </Popup>
    <Popup v-model="pricePicker" round position="bottom">
      <Picker
        value-key="value"
        show-toolbar
        :columns="priceColumns"
        @cancel="pricePicker = false"
        @confirm="priceConfirm"
      />
    </Popup>
  </div>
</template>
<script>
import { Icon, Picker, Popup, NavBar } from "vant";
import {
  getCity,
  coachRegister,
  coachSave,
  coachExtendInfo,
  coachInfo,
  coachExtendUpdate,
  getUserInfo,
  userEdit,
  checkPhone,
  coachRegisterCode,
  comboMemberList,
  registerVerify,
  bindUserSms,
} from "@api/user";
import { getDict } from "@api/admin";
import { VUE_APP_API_URL } from "@utils";
import { getCategory } from "@api/store";
import VueCoreImageUpload from "vue-core-image-upload";
import debounce from "lodash.debounce";
import {
  required,
  alpha_num,
  chs_phone,
  email,
  chs_password,
} from "@utils/validate";
import { validatorDefaultCatch } from "@utils/dialog";
import sendVerifyCode from "@mixins/SendVerifyCode";
import { mapGetters } from "vuex";
import NfInput from "@/components/game-ui/NfInput.vue";

export default {
  name: "SettleIn",
  components: { Icon, Picker, Popup, VueCoreImageUpload, NavBar, NfInput },
  mixins: [sendVerifyCode],
  data: function () {
    return {
      form: {
        sex: 1,
        meetType: [],
        cateId: [],
        aptitudeList: [],
        posterList: [],
        attrs: [{}, {}],
        code: "",
        title: "",
        linkUrl: "",
      },
      stepActive: null,
      showPicker: false,
      columns: [],
      addressOption: [],
      pickerType: "",
      province: {},
      city: {},
      cityColumns: [],
      zone: [],
      priceColumns: [],
      pricePicker: false,
      price: "",
      url: `${VUE_APP_API_URL}/api/upload`,
      headers: {
        Authorization: "Bearer " + this.$store.state.app.token,
      },
      status: 0,
      sexList: [],
      meetList: [],
      packageList: [],
      packageObj: {},
      priceObj: {},
      codeText: "获取验证码",
      memberList: [],
      // 0：普通教练，1：公益教练，2：普通教练+公益教练，3：卡牌引导师，99：普通用户
      currentCoach: 99,
      // 是否是卡牌教练
      isCardCoach: 0,
    };
  },
  computed: mapGetters(["userInfo", "isLogin"]),
  async mounted() {
    await this.getCityList();

    this.stepActive = this.$route.query.stepActive
      ? Number(this.$route.query.stepActive)
      : 1;
    // console.log("this.stepActive", this.stepActive)
    this.getDict("sex_code", (res) => {
      this.sexList = res.data;
      this.form.sex = res.data[0].value;
    });
    this.getDict("meet_type", (res) => {
      this.meetList = res.data;
    });
    this.getDict("standard_pricing", (res) => {
      this.priceColumns = res.data;
    });
    this.getDict("price_package", (res) => {
      this.packageList = res.data;
      res.data.forEach((element) => {
        this.packageObj[element.label] = element.value * 10;
      });
    });
    this.getMemberPriceList();

    this.loadCategoryData();

    // this.getCoachDetail();
  },
  watch: {
    stepActive: {
      handler: function (val) {
        console.log("stepActive");
        // if (this.isLogin) {
        val == 1 && this.getBase();
        val == 2 && this.getInfo();
        val == 3 && this.getExtendInfo();
      },
      // immediate: true,
    },
    userInfo: {
      handler: function (user) {
        // console.log("user", user);
        console.log("更新");
        if (Object.keys(user).length > 0) {
          user.coachType !== null && (this.currentCoach = user.coachType);
          user.isCardCoach !== null && (this.isCardCoach = user.isCardCoach);
        }
      },
      immediate: true,
    },
  },
  methods: {
    getDict: function (name, cal) {
      getDict({ name }).then((res) => {
        cal(res);
      });
    },
    getBase: function () {
      getUserInfo().then((res) => {
        this.form = res.data;
      });
    },
    async codeRequest() {
      var that = this;
      const phone = that.form.phone;
      try {
        await that
          .$validator({
            phone: [
              required(required.message("手机号码")),
              chs_phone(chs_phone.message()),
            ],
          })
          .validate({ phone });
      } catch (e) {
        return validatorDefaultCatch(e);
      }
      // 用户保存信息，否则是教练入驻
      if (this.stepActive == 1 && this.$route.query.stepActive) {
        await bindUserSms({ phone: phone })
          .then((res) => {
            that.$dialog.success(res.msg);
            that.sendCode();
          })
          .catch((res) => {
            that.$dialog.error(res.msg);
          });
      } else {
        await coachRegisterCode({ phone: phone })
          .then((res) => {
            that.$dialog.success(res.msg);
            that.sendCode();
          })
          .catch((res) => {
            that.$dialog.error(res.msg);
          });
      }
    },
    getInfo: function () {
      coachInfo().then((res) => {
        this.form = res.data;
        console.log(555555555555);
        this.province = this.addressOption.find(
          (item) => item.v == res.data.provinceCode
        );
        if (this.province) {
          this.city = this.province.c.find(
            (item) => item.v == res.data.cityCode
          );
        } else {
          this.city = {};
          this.province = {};
        }
        // this.form.cateId = (res.data.cateId || "")
        //   .split(",")
        //   .filter((item) => item != null && item != "");
        // 转为整数型
        this.form.cateId = (res.data.cateId || "")
          .split(",")
          .filter((item) => item != null && item != "")
          .map((item) => parseInt(item));
        console.log("cateId", this.form.cateId);
        this.form.meetType = (res.data.meetType || "").split(",") || [];
      });
    },
    getExtendInfo: function () {
      coachExtendInfo().then((res) => {
        if (res.data.aptitudeList && Array.isArray(res.data.aptitudeList)) {
          res.data.aptitudeList = res.data.aptitudeList.filter((item) => item);
        } else {
          res.data.aptitudeList = [];
        }
        this.form = res.data;
        this.status = res.data.status || 0;
      });
    },
    checkPhoneValue(phone) {
      return new Promise((resolve, reject) => {
        checkPhone({ phone: phone })
          .then((res) => {
            resolve();
          })
          .catch((e) => {
            this.$dialog.toast({ mes: e.msg });
            reject();
          });
      });
    },
    // 数据提交前的校验
    submit: async function () {
      if (this.stepActive === 1) {
        const { realName, phone } = this.form;
        try {
          if (!this.form.avatar) {
            this.$dialog.toast({ mes: "请上传头像" });
            return;
          }
          await this.$validator({
            realName: [required(required.message("姓名"))],
            phone: [
              required(required.message("手机号码")),
              chs_phone(chs_phone.message("手机号码")),
            ],
          }).validate({ realName, phone });
        } catch (e) {
          validatorDefaultCatch(e);
          return Promise.resolve(false);
        }
        // await this.checkPhoneValue(this.form.phone);
        return Promise.resolve(true);
      }
      if (this.stepActive === 2) {
        await this.checkedInput([
          { key: "provinceCode", msg: "请选择省份" },
          { key: "cityCode", msg: "请选择城市" },
          { key: "meetType", msg: "请选择约见方式" },
          { key: "cateId", msg: "请选择擅长领域" },
          { key: "price", msg: "请选择单次价格" },
        ]);
        if (this.form.keyword) {
          const kws = this.form.keyword.replace(/，/g, ",").split(",");
          const y = kws.find((el) => el.length > 6);
          if (y) {
            this.$dialog.toast({
              mes: "自定义领域每个不得超过六个字符",
            });
            return Promise.resolve(false);
          }
        }
        return Promise.resolve(true);
      }
      if (this.stepActive === 3) {
        let checkArr = [
          { key: "cardFront", msg: "请上传身份证正面" },
          { key: "cardBack", msg: "请上传身份证反面" },
          { key: "aptitudeList", msg: "请上传上传资质证明" },
        ];
        if (this.form.passport) {
          checkArr = [
            { key: "passport", msg: "请上传护照" },
            { key: "aptitudeList", msg: "请上传上传资质证明" },
          ];
        }
        await this.checkedInput(checkArr);
        return Promise.resolve(true);
      }
    },
    async coachRegister(type) {
      // 先判断当前是否是教练注册
      // 保存教练数据
      if (type === "coach" && this.stepActive != 1) {
        const status = await this.submit();
        if (!status) return;
        status && this.save();
        return;
      }
      // 走教练注册
      const { realName, phone, code } = this.form;
      let coachName = "";
      type === "card" && (coachName = "卡牌引导师");
      type === "coach" && (coachName = "平台教练");
      type === "welfare" && (coachName = "公益教练");
      try {
        if (!this.form.avatar) {
          this.$dialog.toast({ mes: "请上传头像" });
          return;
        }
        await this.$validator({
          realName: [required(required.message("姓名"))],
          phone: [
            required(required.message("手机号码")),
            chs_phone(chs_phone.message("手机号码")),
          ],
          code: [required(required.message("验证码"))],
        }).validate({ realName, phone, code });
        // cardCoach = (await this.coachConfirm()) || false;
      } catch (e) {
        return validatorDefaultCatch(e);
      }
      // await this.checkPhoneValue(this.form.phone);
      this.$dialog.confirm({
        title: `${coachName}-入驻申请`,
        mes: `申请成为${coachName}？`,
        opts: [
          {
            txt: "取消",
            callback: () => {
              // this.$router.push("/");
            },
          },
          {
            txt: "确认",
            callback: () => {
              const submitData = {
                phone: this.form.phone,
                code: this.form.code,
                realName: this.form.realName,
                avatar: this.form.avatar,
              };
              type === "welfare" && (submitData.coachType = 1);
              type === "coach" && (submitData.coachType = 0);
              type === "card" && (submitData.isCardCoach = 1);
              coachRegister(submitData)
                .then((res) => {
                  console.log(`提交${type}信息`, res);
                  if (res.status == 200) {
                    this.$dialog.confirm({
                      title: "完善个人信息及资料",
                      mes:
                        type === "coach"
                          ? "请继续完善个人信息及资料"
                          : "平台正在审核中，请您关注申请状态。感谢您的支持与关注！",
                      // mes: "请继续完善个人信息及资料",
                      opts: [
                        {
                          txt: "确认",
                          callback: () => {
                            if (type === "coach") {
                              this.$dialog.toast({
                                mes: "您已提交入驻申请，请继续完善您平台教练数据！",
                              });
                              this.stepActive = 2;
                            } else {
                              this.$router.push("/");
                            }
                          },
                        },
                      ],
                    });
                  } else {
                    this.$dialog.error(res.msg);
                  }
                })
                .catch((err) => {
                  this.$dialog.error(err.msg);
                });
            },
          },
        ],
      });
    },
    // 成为教练提交审核
    coachConfirm() {
      return new Promise((resolve) => {
        this.$dialog.confirm({
          mes: "成为普通教练继续完善资料?",
          opts: [
            {
              txt: "卡牌教练",
              color: false,
              callback: () => {
                resolve(true);
              },
            },
            {
              txt: "继续完善",
              color: true,
              callback: () => {
                resolve(false);
              },
            },
          ],
        });
      });
    },
    // 保存数据
    save: debounce(async function () {
      const status = await this.submit();
      console.log("status", status);
      if (!status) return;
      if (this.stepActive == 1) {
        userEdit({
          phone: this.form.phone,
          code: this.form.code,
          wechatNumber: this.form.wechatNumber,
          email: this.form.email,
          realName: this.form.realName,
          bankName: this.form.bankName,
          bankNumber: this.form.bankNumber,
          zfbName: this.form.zfbName,
          zfbNumber: this.form.zfbNumber,
          avatar: this.form.avatar,
        })
          .then((res) => {
            console.log("res", res);
            if (res.status === 200) {
              this.$dialog.toast({
                mes:
                  this.$store.state.app.userCategory == 2
                    ? res.data
                    : "保存成功！",
              });
              setTimeout(() => {
                // 刷新用户信息
                // getUserInfo()
                this.$store.dispatch("USERINFO");
                this.$router.go(-1);
              }, 3000);
            } else {
              this.$dialog.error(res.msg);
            }
          })
          .catch((err) => {
            this.$dialog.error(err.msg);
          });
      }
      if (this.stepActive == 2) {
        coachSave({
          ...this.form,
          tag: this.$route.query.stepActive ? true : undefined,
          meetType: this.form.meetType.join(","),
          cateId: this.form.cateId.join(","),
          ...(this.form.keyword && {
            keyword: this.form.keyword.replace(/，/g, ","),
          }),
        })
          .then((res) => {
            if (res.status === 200) {
              this.$dialog.toast({
                mes: this.$route.query.stepActive
                  ? res.data
                  : "保存成功，请继续完善您的资质信息！",
              });
              setTimeout(() => {
                // 如果是保存信息，保存后跳转到首页
                if (this.$route.query.stepActive) {
                  this.$router.go(-1);
                } else {
                  // 否则跳转到下一步
                  this.stepActive = 3;
                }
              }, 1500);
            } else {
              this.$dialog.error(res.msg);
            }
          })
          .catch((err) => {
            this.$dialog.error(err.msg);
          });
      }
      if (this.stepActive == 3) {
        const aptitudeList =
          this.form.aptitudeList && Array.isArray(this.form.aptitudeList)
            ? this.form.aptitudeList.filter((item) => item)
            : [];
        coachExtendUpdate({
          ...this.form,
          aptitudeList,
          tag: this.$route.query.stepActive ? true : undefined,
        })
          .then((res) => {
            if (res.status === 200) {
              this.$dialog.toast({
                mes: res.data,
              });
              setTimeout(() => {
                this.$router.go(-1);
              }, 3000);
            } else {
              this.$dialog.error(res.msg);
            }
          })
          .catch((err) => {
            this.$dialog.error(err.msg);
          });
      }
    }),
    checkedInput(arr) {
      return new Promise(async (resolve) => {
        for (var i = 0; i < arr.length; i++) {
          const key = arr[i].key;
          if (Array.isArray(this.form[key])) {
            if (!this.form[key].length) {
              this.$dialog.toast({ mes: arr[i].msg });
              return;
            }
          } else {
            if (!this.form[key]) {
              this.$dialog.toast({ mes: arr[i].msg });
              return;
            }
          }
        }
        resolve();
      });
    },
    loadCategoryData: function () {
      getCategory().then((res) => {
        this.zone = res.data;
      });
    },
    // 获取城市列表
    getCityList() {
      let that = this;
      return new Promise((resolve) => {
        getCity()
          .then((res) => {
            this.addressOption = res.data.map((item) => {
              return {
                n: item.n,
                v: item.v,
                c: item.c.map((ele) => ({ n: ele.n, v: ele.v })),
              };
            });
            resolve();
          })
          .catch((err) => {
            that.$dialog.error(err.msg);
            resolve();
          });
      });
    },
    selectPicker: function (type) {
      if (type === "province") {
        this.columns = this.addressOption;
      }
      if (type === "city") {
        this.columns = this.cityColumns;
      }
      this.pickerType = type;
      this.showPicker = true;
    },
    onConfirm: function (e) {
      if (this.pickerType === "province") {
        this.cityColumns = e.c;
        this.form.provinceCode = e.v;
        this.province = { n: e.n, v: e.v };
        this.city = {};
        this.form.cityCode = "";
      }
      if (this.pickerType === "city") {
        this.city = { n: e.n, v: e.v };
        this.form.cityCode = e.v;
      }
      this.showPicker = false;
    },
    priceConfirm: function (e) {
      this.form.price = e.value;
      this.form.attrs = this.memberList.map((item) => {
        if (item.number == 1) {
          return {
            price: (this.form.price * item.number * item.discount).toFixed(2),
            sku: item.number,
            skuName: item.name,
            otPrice: (this.form.price * item.number).toFixed(2),
          };
        } else {
          return {
            price: (this.form.price * item.number * item.discount).toFixed(2),
            sku: item.number,
            skuName: item.name,
            otPrice: (this.form.price * item.number).toFixed(2),
          };
        }
      });
      console.log(this.priceObj);
      this.pricePicker = false;
    },
    appointmentChoose: function (e) {
      const index = this.form.meetType.findIndex((item) => item === e);
      index === -1
        ? this.form.meetType.push(e)
        : this.form.meetType.splice(index, 1);
    },
    zoneChoose: function (e) {
      console.log("this.form.cateId", this.form.cateId);
      const index = (this.form.cateId || []).findIndex((item) => item == e);
      index === -1
        ? this.form.cateId.length > 2
          ? null
          : this.form.cateId.push(e)
        : this.form.cateId.splice(index, 1);
    },
    imageuploaded(res, type) {
      if (res.errno !== 0) return this.$dialog.error(res.msg || "上传图片失败");
      this.form[type] = res.link;
      this.$forceUpdate();
    },
    imageMoreUploaded(res) {
      if (res.errno !== 0) return this.$dialog.error(res.msg || "上传图片失败");
      Array.isArray(this.form["aptitudeList"]) ||
        (this.form["aptitudeList"] = []);
      this.form["aptitudeList"].push(res.link);
    },
    imagePosterUploaded(res) {
      // console.log(res, "res上传图片失败");
      if (res.errno !== 0) return this.$dialog.error(res.msg || "上传图片失败");
      Array.isArray(this.form["posterList"]) || (this.form["posterList"] = []);
      this.form["posterList"].push(res.link);
    },
    imageErrorhandle(res) {
      this.$dialog.error("图片上传失败，请检查格式或者图片大小是否超过5M");
    },
    getMemberPriceList() {
      comboMemberList()
        .then((res) => {
          this.memberList = res.data;
          console.log("memberList", this.memberList);
        })
        .catch((err) => {
          this.memberList = err.data;

          console.log(err);
        });
    },
  },
};
</script>
<style>
.more-img {
  width: 5.27rem;
  height: 3rem;
  margin: 0.19rem;
  position: relative;
}

.passport-img {
  width: 5.27rem;
  height: 7.24rem;
}

.close-img {
  position: absolute;
  z-index: 1;
  right: 0;
  top: 0;
}

.name {
  position: relative;
}

.name.red {
  color: #ff1200;
}

.name.required::after {
  content: "*";
  position: absolute;
  left: -0.2rem;
  top: 0;
  color: #ff1200;
}
</style>
